import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Menu } from 'antd';
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { LeftMenuContainer, LeftMenu, CollapsedButtonContainer, AvatarContainer, AvatarPanel } from './styled';
import useBasicMenu from './useBasicMenu';

const BasicLeftMenu = () => {
    const { pathname } = useLocation();

    const rootRoute = useBasicMenu();

    const { routes } = rootRoute;

    const icon = 'https://afc-uat.s3.amazonaws.com/user/profile/5f896275e7bf69001bc00c83.png';
    const activeUserName = 'PFS Admin';

    const [collapsed, setCollapsed] = React.useState(false);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    return (
        <LeftMenuContainer>
            <CollapsedButtonContainer>
                <Button
                    onClick={toggleCollapsed}
                    style={{
                        marginBottom: 0,
                    }}
                >
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </Button>
            </CollapsedButtonContainer>
            <AvatarContainer hidden={collapsed}>
                <AvatarPanel>
                    <div style={{ paddingTop: '30px' }}>
                        <img alt="icon" src={icon} style={{ width: 75, height: 75 }} />
                    </div>
                    <div style={{ paddingTop: '30px' }}>
                        <p>{activeUserName}</p>
                    </div>
                </AvatarPanel>
            </AvatarContainer>
            <LeftMenu inlineCollapsed={collapsed} mode="inline" selectedKeys={pathname}>
                {routes.map(route => (
                    <Menu.Item key={route.href} hidden={collapsed} icon={route.icon}>
                        <Link to={route.href}>{route.label}</Link>
                    </Menu.Item>
                ))}
            </LeftMenu>
        </LeftMenuContainer>
    );
};

export default BasicLeftMenu;
